import React from "react";

export const TreasureViewInfoImage = ({
  Content = <g></g>,
}: {
  Content: React.ReactNode;
}) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 494 423"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_9302_11909)">
        <rect
          x="66.2507"
          y="37"
          width="361.499"
          height="378"
          rx="20"
          fill="black"
          fillOpacity="0.9"
        />
        <rect
          x="68.2507"
          y="39"
          width="357.499"
          height="374"
          rx="18"
          stroke="url(#paint0_linear_9302_11909)"
          strokeWidth="4"
        />
        <rect
          x="68.2507"
          y="39"
          width="357.499"
          height="374"
          rx="18"
          stroke="url(#paint1_linear_9302_11909)"
          strokeWidth="4"
          //   style="mix-blend-mode:overlay"
        />
        <rect
          x="68.2507"
          y="39"
          width="357.499"
          height="374"
          rx="18"
          stroke="#C1A875"
          strokeWidth="4"
          //   style="mix-blend-mode:color"
        />
      </g>
      <g filter="url(#filter1_f_9302_11909)">
        <rect
          x="44.6472"
          y="29"
          width="407.586"
          height="378"
          rx="20"
          fill="black"
          fillOpacity="0.9"
        />
        <rect
          x="46.6472"
          y="31"
          width="403.586"
          height="374"
          rx="18"
          stroke="url(#paint2_linear_9302_11909)"
          strokeWidth="4"
        />
        <rect
          x="46.6472"
          y="31"
          width="403.586"
          height="374"
          rx="18"
          stroke="url(#paint3_linear_9302_11909)"
          strokeWidth="4"
          //   style="mix-blend-mode:overlay"
        />
        <rect
          x="46.6472"
          y="31"
          width="403.586"
          height="374"
          rx="18"
          stroke="#C1A875"
          strokeWidth="4"
          //   style="mix-blend-mode:color"
        />
      </g>
      <g filter="url(#filter2_f_9302_11909)">
        <rect
          x="24.484"
          y="19"
          width="445.032"
          height="378"
          rx="20"
          fill="black"
          fillOpacity="0.9"
        />
        <rect
          x="26.484"
          y="21"
          width="441.032"
          height="374"
          rx="18"
          stroke="url(#paint4_linear_9302_11909)"
          strokeWidth="4"
        />
        <rect
          x="26.484"
          y="21"
          width="441.032"
          height="374"
          rx="18"
          stroke="url(#paint5_linear_9302_11909)"
          strokeWidth="4"
          //   style="mix-blend-mode:overlay"
        />
        <rect
          x="26.484"
          y="21"
          width="441.032"
          height="374"
          rx="18"
          stroke="#C1A875"
          strokeWidth="4"
          //   style="mix-blend-mode:color"
        />
      </g>
      <g filter="url(#filter3_b_9302_11909)">
        <rect
          x="10.0817"
          y="10"
          width="472.397"
          height="378"
          rx="20"
          fill="black"
          fillOpacity="0.9"
        />
        <rect
          x="12.0817"
          y="12"
          width="468.397"
          height="374"
          rx="18"
          stroke="url(#paint6_linear_9302_11909)"
          strokeWidth="4"
        />
        <rect
          x="12.0817"
          y="12"
          width="468.397"
          height="374"
          rx="18"
          stroke="url(#paint7_linear_9302_11909)"
          strokeWidth="4"
          //   style="mix-blend-mode:overlay"
        />
        <rect
          x="12.0817"
          y="12"
          width="468.397"
          height="374"
          rx="18"
          stroke="#C1A875"
          strokeWidth="4"
          //   style="mix-blend-mode:color"
        />
      </g>
      <g filter="url(#filter4_b_9302_11909)">
        <rect width="494" height="378" rx="20" fill="black" fillOpacity="0.9" />
        <rect
          x="221.5"
          y="79"
          width="50"
          height="50"
          rx="25"
          fill="#B39F76"
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M244.768 107.058C244.078 106.794 243.33 106.443 242.847 106.178C241.877 105.645 241.339 105.145 240.134 104.189C239.856 103.969 239.577 103.721 239.296 103.506C238.202 102.689 237.137 101.974 235.949 101.299L235.272 100.942C234.754 100.67 234.109 100.393 233.572 100.167C233.443 100.112 233.144 100.042 233.06 99.8788C233.032 99.8244 232.998 99.7422 233.035 99.6683C233.069 99.6016 233.155 99.5527 233.27 99.5074C233.399 99.4569 233.514 99.4072 233.616 99.3893C233.68 99.3783 233.715 99.3883 233.776 99.3662C233.854 99.3381 233.874 99.2858 234.004 99.25C234.209 99.1932 234.451 99.1999 234.641 99.2067C235.219 99.2273 235.76 99.4244 236.342 99.6346C237.306 99.9823 238.319 100.419 239.215 100.618C239.859 100.761 240.551 100.836 241.213 100.865C241.482 100.863 241.853 100.868 242.227 100.82C242.683 100.763 243.143 100.64 243.436 100.499C243.69 100.376 243.703 100.223 243.86 99.6522C243.779 99.5975 243.711 99.5488 243.687 99.4873C243.664 99.4296 243.681 99.3655 243.763 99.2887C243.817 99.2396 243.874 99.1992 243.941 99.151L243.934 98.8356L243.949 98.4544C243.956 98.3517 243.961 98.2525 243.983 98.1628C244.015 98.0281 244.083 97.9148 244.248 97.8417C244.389 97.7795 244.516 97.8185 244.64 97.7474C244.651 97.7409 244.768 97.6129 244.792 97.5882C244.848 97.5331 244.9 97.4788 244.951 97.422C245.05 97.3115 245.141 97.1891 245.254 97.0604C245.301 97.0066 245.309 96.9812 245.221 96.8783C245.146 96.7901 245.082 96.7106 245.067 96.5999C245.029 96.3318 245.143 96.0348 245.304 95.889C245.402 95.8005 245.476 95.6776 245.593 95.6262C245.778 95.5444 245.98 95.6575 246.152 95.8821C246.273 96.0395 246.369 96.2844 246.376 96.4087C246.382 96.4995 246.38 96.6539 246.34 96.7446C246.294 96.8478 246.213 96.8396 246.198 96.952C246.193 96.9823 246.206 97.0158 246.242 97.0651L246.793 97.7445C247.131 97.7836 247.336 97.8773 247.405 98.2395C247.443 98.4389 247.439 98.6015 247.452 98.8248L247.454 99.0609C247.454 99.1283 247.454 99.1263 247.512 99.1535C247.592 99.1907 247.674 99.2442 247.714 99.3212C247.748 99.3868 247.733 99.4596 247.641 99.5528L247.668 99.7249C247.797 100.561 248.165 100.713 249.159 100.529C249.675 100.434 250.119 100.172 250.642 99.8248C251.367 99.3433 252.044 98.7921 252.822 98.3253C253.237 98.0921 253.654 97.855 254.1 97.615C255.174 97.0367 256.34 96.5122 257.516 96.4971C257.961 96.4913 258.396 96.5769 258.708 96.8574C258.949 97.0733 259.041 97.4115 258.944 97.9223C258.837 98.4885 258.513 99.0171 258.217 99.5009C257.909 100.006 257.619 100.351 257.063 100.778C256.232 101.417 255.56 101.93 254.587 102.475C253.964 102.824 253.262 103.191 252.655 103.517C252.277 103.76 251.853 104.006 251.431 104.263C250.848 104.616 250.27 104.989 249.819 105.396C249.606 105.59 249.316 105.885 249.042 106.08C248.428 106.518 247.846 106.651 246.828 107.007C246.876 107.442 246.898 108.041 247.139 108.4C247.492 108.5 247.827 108.582 248.096 108.855C248.224 108.985 248.317 109.144 248.308 109.321L248.411 109.361C248.659 109.456 248.854 109.551 249.091 109.665C249.194 109.715 249.288 109.796 249.389 109.871C249.602 110.029 249.804 110.22 249.876 110.462C249.921 110.611 249.909 110.707 249.903 110.917L249.92 111.537C249.578 112.046 249.046 112.365 248.415 112.561C247.471 112.855 246.323 112.93 245.554 112.904C245.003 112.886 244.444 112.829 243.9 112.687C243.323 112.535 242.025 112.115 241.918 111.37C241.91 111.312 241.899 111.235 241.899 111.222C241.899 111.201 241.893 110.901 241.893 110.901C241.895 110.796 241.864 110.704 241.884 110.622C241.935 110.42 241.994 110.228 242.184 110.025C242.456 109.735 242.621 109.638 242.859 109.538C242.974 109.49 243.116 109.452 243.283 109.374C243.31 109.361 243.36 109.353 243.385 109.337C243.403 109.326 243.366 109.236 243.428 109.111C243.509 108.947 243.719 108.723 244.045 108.562C244.247 108.461 244.464 108.422 244.464 108.421C244.645 108.108 244.714 107.343 244.768 107.058H244.768ZM256.912 98.8904C256.759 99.1873 256.531 99.475 256.429 99.6009C255.688 100.51 254.699 101.167 253.564 101.76C253.156 101.973 252.714 102.13 252.363 102.19C252.268 102.206 252.131 102.221 252.021 102.215C251.687 102.195 251.645 101.983 251.664 101.668C251.675 101.495 251.719 101.306 251.794 101.149C252.093 100.513 252.815 99.7987 253.62 99.2819C253.829 99.1473 254.043 98.995 254.255 98.8787C254.407 98.7958 255.087 98.4638 255.71 98.2569C255.985 98.1653 256.948 97.8697 257.02 98.3093C257.042 98.4493 257.059 98.606 256.912 98.8904Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="2.61313"
          strokeLinejoin="round"
        />
        <rect
          x="2"
          y="2"
          width="490"
          height="374"
          rx="18"
          stroke="url(#paint10_linear_9302_11909)"
          strokeWidth="4"
        />
        <rect
          x="2"
          y="2"
          width="490"
          height="374"
          rx="18"
          stroke="url(#paint11_linear_9302_11909)"
          strokeWidth="4"
          //   style="mix-blend-mode:overlay"
        />
        <rect
          x="2"
          y="2"
          width="490"
          height="374"
          rx="18"
          stroke="#C1A875"
          strokeWidth="4"
          //   style="mix-blend-mode:color"
        />
      </g>

      {Content}
      <defs>
        <filter
          id="filter0_f_9302_11909"
          x="58.2507"
          y="29"
          width="377.499"
          height="394"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4"
            result="effect1_foregroundBlur_9302_11909"
          />
        </filter>
        <filter
          id="filter1_f_9302_11909"
          x="40.6472"
          y="25"
          width="415.586"
          height="386"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_9302_11909"
          />
        </filter>
        <filter
          id="filter2_f_9302_11909"
          x="22.484"
          y="17"
          width="449.032"
          height="382"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_9302_11909"
          />
        </filter>
        <filter
          id="filter3_b_9302_11909"
          x="-69.9183"
          y="-70"
          width="632.397"
          height="538"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="40" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_9302_11909"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_9302_11909"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_b_9302_11909"
          x="-80"
          y="-80"
          width="654"
          height="538"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="40" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_9302_11909"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_9302_11909"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_9302_11909"
          x1="86.2935"
          y1="273.416"
          x2="424.941"
          y2="197.549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9302_11909"
          x1="210.559"
          y1="226"
          x2="132.654"
          y2="31.5656"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9302_11909"
          x1="67.2452"
          y1="265.416"
          x2="444.181"
          y2="170.206"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9302_11909"
          x1="207.353"
          y1="218"
          x2="136.156"
          y2="17.6524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9302_11909"
          x1="49.1582"
          y1="255.416"
          x2="456.034"
          y2="143.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_9302_11909"
          x1="202.138"
          y1="208"
          x2="135.731"
          y2="3.96438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_9302_11909"
          x1="36.273"
          y1="246.416"
          x2="464.332"
          y2="121.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_9302_11909"
          x1="198.659"
          y1="199"
          x2="135.418"
          y2="-7.25812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_9302_11909"
          x1="157.589"
          y1="243.657"
          x2="296.948"
          y2="154.217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_9302_11909"
          x1="226.339"
          y1="234.5"
          x2="220.361"
          y2="191.758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_9302_11909"
          x1="27.3891"
          y1="236.416"
          x2="471.742"
          y2="100.381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#576265" />
          <stop offset="0.172016" stopColor="#9EA1A1" />
          <stop offset="0.45741" stopColor="#848B8A" />
          <stop offset="0.553567" stopColor="#576265" />
          <stop offset="0.823421" stopColor="#576265" />
          <stop offset="0.925155" stopColor="#757A7B" />
          <stop offset="1" stopColor="#576265" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_9302_11909"
          x1="197.202"
          y1="189"
          x2="136.278"
          y2="-18.7857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
